// extracted by mini-css-extract-plugin
module.exports = {"Snackbar":"Banner_Snackbar__1k7QP"};